import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import ProductCategoryVisNavCard from './ProductCategoryVisNavCard';
import { normalizeVisNav, addSpecialSavingsToVisNav } from '../utils/helpers/navigationHelpers';
import { handleVisNavCardSelect } from '../utils/analytics/visualCategoryNavAnalytics';

export const ProductCategoryVisNavGrid = ({
  visualNavs,
  visualNavContainsEvents,
  dimensions,
  urlAddOn,
}) => {
  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';

  if (!visualNavs?.length) {
    return null;
  }

  // First normalize all visual navs
  const baseNormalizedVisNavs = visualNavs.map((visualNav, index) => normalizeVisNav(visualNav, isMobile, index));

  // Then add special savings if needed
  const finalVisNavs = !visualNavContainsEvents
    ? addSpecialSavingsToVisNav(baseNormalizedVisNavs, dimensions)
    : baseNormalizedVisNavs;

  return (
    <section className="sui-overflow-x-auto">
      <div className="sui-flex sui-flex-nowrap sui-mb-4 sui-mt-1 sui-gap-4 md:sui-gap-6 lg:sui-gap-8">
        {finalVisNavs.map(({
          key, url, label, analytics, src, categoryId
        }, index
        ) => {
          let newUrl = url;
          if (urlAddOn) {
            const visNavParam = `visNavSearch=${encodeURIComponent(`${urlAddOn}-_-${index + 1}-_-${categoryId}`)}`;
            newUrl = url.includes('?')
              ? `${url}&${visNavParam}`
              : `${url}?${visNavParam}`;
          }
          return (
            <ProductCategoryVisNavCard
              key={key}
              href={newUrl}
              src={src}
              label={label}
              onClick={() => handleVisNavCardSelect({ ...analytics, position: index + 1 })}
            />
          );
        })}
      </div>
    </section>
  );
};

ProductCategoryVisNavGrid.defaultProps = {
  visualNavs: [],
  visualNavContainsEvents: false,
  urlAddOn: ''
};

ProductCategoryVisNavGrid.propTypes = {
  visualNavs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      imageId: PropTypes.string,
      webUrl: PropTypes.string,
      categoryId: PropTypes.string,
      imageURL: PropTypes.string,
    })
  ),
  visualNavContainsEvents: PropTypes.bool,
  dimensions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  urlAddOn: PropTypes.string
};

export default ProductCategoryVisNavGrid;
